<div class="flex-column middle justify section container">
    <mat-form-field class="mat-pickers fields">
        <mat-label>Device</mat-label>
        <mat-select [value]="device$ | async" (valueChange)="deviceUuid$.next($event.uuid)">
            <mat-option *ngFor="let device of devices$ | async" [value]="device">
                {{ device.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="fields">
        <mat-label>Time Duration</mat-label>
        <time-picker 
            [isDurationSelector]="true" 
            [value]="interval" 
            (valueChange)="onTimeIntervalChange($event)">
        </time-picker>
    </mat-form-field>

    <mat-form-field class="fields">
        <mat-label>Off Spec Alert Percent</mat-label>
        <input matInput type="number" [(ngModel)]="offSpecAlertPercent" placeholder="Enter the Off Spec Percent for alerts" />
    </mat-form-field>

    <mat-form-field class="fields">
        <mat-label>Emails For Alert</mat-label>
        <mat-chip-grid #chipGrid aria-label="Enter emails">
            <mat-chip-row *ngFor="let email of alertEmails" (removed)="removeEmail(email)" [removable]="true">
                {{email}}
                <button matChipRemove [attr.aria-label]="'remove ' + email">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
            <input placeholder="New email..." [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addEmail($event)" [formControl]="emailFormControl" />
        </mat-chip-grid>
    </mat-form-field>
    <button 
        mat-raised-button 
        color="primary"
        [disabled]="!valid()"
        class="section container mt-20" 
        (click)="saveSettings()"
        aria-label="Save Interval Settings">
        Save Alert Settings
    </button>
</div>